import { z } from 'zod/v4';

/**
 * `confirmation` is the literal word `public`: making a document public is not
 * reversible once anyone can read it, so the caller has to spell the decision out.
 * The body shape is the legacy one, so both frontends send it unchanged.
 */
export const MakeCompanyDocumentPublicBodySchema = z.strictObject({
  id: z.string().min(1),
  confirmation: z.literal('public'),
});

export type MakeCompanyDocumentPublicBody = z.infer<
  typeof MakeCompanyDocumentPublicBodySchema
>;
